import { titleUI } from 'platform/forms-system/src/js/web-component-patterns';
import CaregiverSsnDescription from '../../../components/FormDescriptions/CaregiverSsnDescription';
import { ssnUI } from '../../../definitions/sharedUI';
import content from '../../../locales/en/content.json';
import { FULL_SCHEMA } from '../../../utils/imports';

const TITLE_TEXT = content['secondary-one-info-title--id'];
const INPUT_LABEL = content['secondary-one-input-label'];

const { ssn } = FULL_SCHEMA.definitions;

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT, CaregiverSsnDescription),
    secondaryOneSsnOrTin: ssnUI({ label: INPUT_LABEL, type: 'ssntin' }),
  },
  schema: {
    type: 'object',
    properties: {
      secondaryOneSsnOrTin: ssn,
    },
  },
};
